module.exports = __webpack_public_path__ + "img/retour.94a1147.png";